export default __webpack_public_path__ + "static/media/txt.916fc7fd.svg";